import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M21.334.318c1.738.207 3.27.52 4.357.945 4.447 1.728 5.476 6.646 5.476 6.646.664 2.757.863 5.582.83 8.107.033 2.493-.2 5.317-.863 8.108 0 0-1.029 4.918-5.477 6.646-1.07.425-2.59.728-4.323.928V.318Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M21.333.318v31.38c-1.654.19-3.502.286-5.333.302a50.558 50.558 0 0 1-5.334-.314V.314A50.525 50.525 0 0 1 16 0c1.83.016 3.676.12 5.333.318Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M10.667.314v31.372c-1.733-.204-3.255-.508-4.325-.916C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.318.863-8.109 0 0 1.03-4.918 5.476-6.646C7.412.821 8.934.518 10.667.314Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#78742A",
      d: "M13.53 12.658c-.349.229-.452.555-.286.925.072.159.156.171.539.175l.14.003c.257.008.364.048.375.115.005.025-.012.063-.067.125a1.43 1.43 0 0 1-.09.091l-.114.105c-.335.31-.463.559-.335.92.081.23.249.322.538.377l.075.014c.17.031.217.052.225.078.051.155-.498.548-.708.474-.05-.017-.065-.04-.1-.142-.122-.367-.217-.524-.55-.747-.058-.039-.061-.064-.03-.224a1.22 1.22 0 0 0 .023-.16c.018-.266-.118-.464-.458-.601a.167.167 0 0 0-.125.309c.212.085.258.153.25.27a.954.954 0 0 1-.018.12c-.054.28-.034.425.172.563.26.173.32.273.42.575.064.19.136.291.304.351.446.158 1.285-.442 1.137-.893-.064-.193-.189-.247-.482-.3l-.072-.014c-.184-.035-.257-.075-.287-.16-.07-.2 0-.336.247-.566l.116-.106a1.72 1.72 0 0 0 .112-.113c.114-.13.17-.255.146-.4-.048-.294-.284-.381-.693-.394a6.742 6.742 0 0 0-.147-.003c-.162-.002-.255-.015-.239.02-.097-.216-.05-.367.165-.508a.167.167 0 1 0-.182-.28Z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M14.56 16.24c.368 0 .699.184.699 0s-.261-.994-.63-.994c-.368 0-.405.303-.405.487s-.032.507.336.507Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement("rect", { width: 2, height: 1, x: 15, y: 18, fill: "#E87E04", rx: 0.5 }),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#4BB7C0",
      fillRule: "evenodd",
      d: "M16 17.86c-.073.307-.068.55 0 .56.078.086.325.029.448.028.052-.415.404-.544.518-.542 1.341.27 1.864-.168 1.602-.589-.225-.36-.338-.048-1.19 0-.284.016-.78-.112-1.236-.15-1.825-.148-2.727-.737-2.963-.905-.405-.287-.515.146-.515.33 0 .184 1.422 1.535 3.336 1.267Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M16.76 17.34c.605 0 .698.517.943.32.244-.196-.338-.884-.943-.884s-.885.38-.885.563c0 .184.28 0 .885 0Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#9C3900",
      fillRule: "evenodd",
      d: "M16.728 17.01c.06 0 .426-.08.467-.222.549.278 1.567.157 1.618-.047.07-.283-1.602-.89-1.618-1.192-.016-.305-.123-.557-.26-.852-.01-.024 1.717.637 2.361 2.044.612-1.754-.467-3.425-.644-3.71-.41-.656-2.734-1.569-3.172-.994-.313.502.886.324.625.94-1.35-1.268-1.942-.076-1.989.172-.355.327-.238.574 0 .603.107.013.106-.138.265-.232.337.12.636-.248.652-.188.094.37-.65 1.213-.077 1.983.444.596-.432.854.176 1.12.608.265.694-.295.868-.167.135.1.575.742.728.742Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1FCE6D",
      d: "M11.334 15.333a4.667 4.667 0 1 0 9.333 0 .333.333 0 1 0-.667 0 4 4 0 1 1-8 0 .333.333 0 0 0-.666 0Z"
    }
  )
);
var SvgFlagMex = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagMex_default = SvgFlagMex;

export { FlagMex_default as default };
